module.exports = __webpack_public_path__ + "img/Refresh.4bb8ac96.svg";